export const validateDate = (parts: string[]) => {
	// since year can be in front for yyyy-mm-dd and in last for dd-mm-yyyy taking care of that logic
	const year = parts[0].length === 4 ? parts[0] : parts[2];

	// month will be always in center
	const month = parts[1];
	// taking care of day for the different formats like yyyy-mm-dd or dd-mm-yyyy
	const day = parts[0].length === 4 ? parts[2] : parts[0];

	// creating date our of the year, month day
	const someDate = new Date(+year, +month - 1, +day);

	// validates leapyear and dates exceeding month limit
	const isValidDate = Boolean(+someDate) && someDate.getDate() === Number.parseInt(day, 10);

	// isValid date is true if the date is valid else false
	return isValidDate;
};

export const breakDate = (value: string) => {
	if (value && String(value).length < 10) {
		return null;
	}
	const splitter = value.replace(/[0-9]/g, '')[0];
	const parts = value.split(splitter);

	if (!validateDate(parts)) {
		return null;
	}
	// initializing string dates
	let year = '0000';
	let month = '00';
	let day = '00';

	// As per format YYYY-MM-DD *year* will be first else DD.MM.YYYY *year* will be last
	if (parts[0].length === 4) {
		year = String(Number.parseInt(parts[0], 10));
		month = String(Number.parseInt(parts[1], 10));
		day = String(Number.parseInt(parts[2], 10));
	} else {
		year = String(Number.parseInt(parts[2], 10));
		month = String(Number.parseInt(parts[1], 10));
		day = String(Number.parseInt(parts[0], 10));
	}
	// expect string year: "1999", month: "8" 0r "12", day: "2" or "10"
	return {
		year,
		month,
		day
	};
};
